const templateUrl = require('./../views/partials/my-cause-card.html');
const myCauseCard = () => {
  return {
    scope: {
      myCause: '&',
      savings: '&'
    },
    templateUrl,
    restrict: 'E',
    link: function(scope, el, attrs) {
      scope.myCause = scope.myCause();
      scope.savings = scope.savings();
    }
  }
};
export default myCauseCard;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/myCauseCard.js